import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex custom-background-height container" }
const _hoisted_2 = { class: "col-12 col-md-10 col-lg-7 col-xxl-6 pt-5 pb-5 mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-primary fw-normal px-5 mb-3" }, "Ask for quote", -1)
const _hoisted_4 = { class: "bg-light shadow rounded-5 p-3 p-sm-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "my-4" }, [
  /*#__PURE__*/_createTextVNode(" You are using a free licence for the platform, with limited access."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" You can create 1 project with up to 20 respondents. If you like our solution, ask for a quote and we will contact you as soon as possible. ")
], -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "col-12 col-sm-5 col-md-4 col-lg-5 col-xl-4 ms-auto" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "fa fa-spinner fa-spin",
  "aria-hidden": "true"
}

import { reactive, ref } from "vue";
import { toast } from "vue3-toastify";
import { impalaApi } from "@/main.ts";
import BaseInputPill from "@/components/base-components/BaseInputPill.vue";


const __default__ = {
  name: "Credits",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loading = ref(false);
let form = reactive({
  name: "",
  email: "",
  surname: "",
  company: "",
  profession: "",
});

const resetForm = () => {
  form.name = "";
  form.email = "";
  form.surname = "";
  form.company = "";
  form.profession = "";
};

const submit = async () => {
  try {
    loading.value = true;
    await impalaApi.post("/public/quote", form);
    toast.success("The client was registered successfully!");
    resetForm();
  } catch (error: never) {
    toast.error(error.response.data.message);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("form", {
          onSubmit: _withModifiers(submit, ["prevent"]),
          role: "form",
          class: "ui form"
        }, [
          _createVNode(BaseInputPill, {
            value: _unref(form).name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
            name: "name-get-quote",
            type: "text",
            id: "name-get-quote",
            "aria-placeholder": "Name",
            placeholder: "Name",
            required: ""
          }, null, 8, ["value"]),
          _createVNode(BaseInputPill, {
            value: _unref(form).surname,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).surname) = $event)),
            name: "surname-get-quote",
            type: "text",
            id: "surname-get-quote",
            "aria-placeholder": "Surname",
            placeholder: "Surname",
            required: ""
          }, null, 8, ["value"]),
          _createVNode(BaseInputPill, {
            value: _unref(form).company,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).company) = $event)),
            name: "company-get-quote",
            type: "text",
            id: "company-get-quote",
            "aria-placeholder": "Company",
            placeholder: "Company",
            required: ""
          }, null, 8, ["value"]),
          _createVNode(BaseInputPill, {
            value: _unref(form).profession,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).profession) = $event)),
            name: "profession-get-quote",
            type: "text",
            id: "profession-get-quote",
            "aria-placeholder": "Profession",
            placeholder: "Profession",
            required: ""
          }, null, 8, ["value"]),
          _createVNode(BaseInputPill, {
            value: _unref(form).email,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).email) = $event)),
            name: "email-get-quote",
            type: "email",
            id: "email-get-quote",
            "aria-placeholder": "E-mail",
            placeholder: "E-mail",
            required: ""
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              disabled: loading.value,
              class: "btn btn-primary text-white rounded-pill my-3 w-100",
              type: "submit"
            }, [
              _createTextVNode(" Ask for a quote "),
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                : _createCommentVNode("", true)
            ], 8, _hoisted_8)
          ])
        ], 40, _hoisted_6)
      ])
    ])
  ]))
}
}

})